import React from 'react';

import { PageTitle } from '../../../components';
import { Features } from '../../../sections';


const FeaturePage = () => { 

  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Features'} page={'Features'} />

      {/* Features Section */}
      <Features />
 
    </>
  )
}

export default FeaturePage;